import React, { Component } from "react";
import { Button } from "@material-ui/core";
import Loader from "../../../../loader";
import { NotificationManager } from "react-notifications";
import swal from "sweetalert";
import axios from "axios";

export default class DownloadPreviewZip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  handleDownload = async () => {

    swal({
      title: "Are you sure?",
      text: "You want to download preview zip",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (success) => {

      if (success) {

        try {

          this.setState({
            isLoaded: true,
          });

          // =====================================
          // API CALL
          // =====================================

          const response = await axios.get(
            "https://jccreations.boutique/api/embroidery/download-preview-zip",
            {
              responseType: "blob",
            }
          );

          // =====================================
          // CREATE ZIP DOWNLOAD
          // =====================================

          const blob = new Blob(
            [response.data],
            {
              type: "application/zip",
            }
          );

          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute(
            "download",
            `preview-files-${Date.now()}.zip`
          );

          document.body.appendChild(link);

          link.click();

          link.remove();

          window.URL.revokeObjectURL(url);

          NotificationManager.success(
            "Preview zip downloaded successfully",
            "Success"
          );

          this.setState({
            isLoaded: false,
          });

        } catch (err) {

          console.log(err);

          this.setState({
            isLoaded: false,
          });

          NotificationManager.error(
            "Failed to download preview zip",
            "Error"
          );
        }
      }
    });
  };

  render() {

    const { isLoaded } = this.state;

    return (
      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">
              Download Preview Zip
            </h2>
          </div>

          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button
              variant="contained"
              onClick={this.handleBack}
            >
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>

        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">
            <a href="/">Dashboard</a>
          </li>

          <li className="breadcrumb-item">
            <a href="/admin/product/list">
              Products
            </a>
          </li>

          <li className="breadcrumb-item active">
            Download Preview Zip
          </li>
        </ol>

        <div className="row">

          {isLoaded && <Loader />}

          <div className="col-lg-6 col-md-6">

            <div className="card card-static-2 mb-30">

              <div className="card-title-2">
                <h4>Download Preview Files</h4>
              </div>

              <div className="card-body-table">

                <div className="news-content-right pd-20">

                  <div
                    style={{
                      padding: "15px",
                      background: "#f8f8f8",
                      borderRadius: "8px",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "10px",
                        fontSize: "14px",
                      }}
                    >
                      Clicking download will:
                    </p>

                    <ul
                      style={{
                        paddingLeft: "20px",
                        marginBottom: 0,
                      }}
                    >
                      <li>
                        Delete all PNG files from previews
                        folder
                      </li>

                      <li>
                        Zip all remaining files
                      </li>

                      <li>
                        Download zip automatically
                      </li>
                    </ul>
                  </div>

                  <div className="button_price">

                    <div
                      className="form-group"
                      style={{
                        display: "block",
                      }}
                    >
                      <button
                        className="save-btn hover-btn"
                        type="button"
                        onClick={this.handleDownload}
                      >
                        Download Preview Zip
                      </button>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/fileuploads/download/index.js